import { FiltersItems } from './Filters';

export interface AliasProjectSite {
  id: number;
  name: string;
  status: string;
}

export interface AliasUserInfo {
  id: number;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  is_superuser: boolean;
}

export interface AliasResultsI {
  id: number;
  smtp_alias: string;
  is_active: true;
  project: AliasProjectSite | null;
  site: AliasProjectSite | null;
  user: AliasUserInfo;
}

export interface AliasResponseI {
  count: number;
  next: string;
  previous: null | number;
  results: AliasResultsI[];
}

export interface AliasRequestI {
  ordering: string;
  filters: string;
  page: number;
  page_size: number;
}

export interface FiltersAliasInterface {
  site: FiltersItems;
  user: FiltersItems;
  is_active: FiltersItems;
  search: FiltersItems;
}

export const filtersAliasDefault: FiltersAliasInterface = {
  site: { id: 'site', value: '' },
  is_active: { id: 'is_active', value: 'true' },
  user: { id: 'user', value: '' },
  search: { id: 'search', value: '' },
};

export const defaultAliasRequest: AliasRequestI = {
  page: 1,
  page_size: 10,
  ordering: '-smtp-alias',
  filters: '',
};
